import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=12883ac8&scoped=true"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"
import style0 from "./TemplateDefault.vue?vue&type=style&index=0&id=12883ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12883ac8",
  null
  
)

export default component.exports